import React from 'react';

const Home = () => {
  return (
<div class="main">
			<h1>
        <span style={{"letterSpacing":"-0.05em"}}>H</span> <span style={{"letterSpacing":"0.05em"}}>á</span> <span style={{"letterSpacing":"0.0em"}}>k</span> <span style={{"letterSpacing":"0.02em"}}>a</span> <span style={{"letterSpacing":"-0.04em"}}>r</span>l</h1>
      <img class="main" src = "hakarl.jpg" alt="Hákarl" />

			<p>This is a website for Hákarl, the solo project of Kev Nickells of Brighton, UK. I play violin, oud, and guitar as my main instruments and I've dabbled in drums, sax, clarinet (etc). Also contained here are other projects past and future, photos (mostly by the amazing <a rel="nofollow noopener noreferrer" href="https://www.flickr.com/photos/agataurbaniak" target="_blank">Agata Urbaniak</a>), and bits of writing I've done.</p>

  <p>As well as Hákarl, I'm also playing with Psanck and Three Cornered Corpse. Psanck can be listened to <a rel="nofollow noopener noreferrer" href="https://psanck.bandcamp.com" target="_blank">a their bandcamp</a> and there's a few three Cornered Corpse things on this website.</p>

			<p>If you're here mistakenly looking for the Icelandic foodstuff <a rel="nofollow noopener noreferrer" href="https://en.wikipedia.org/wiki/Hákarl" target="_blank">Hákarl</a> then I'm afraid you're in the wrong place. If you're interested in watching people vomit then <a rel="nofollow noopener noreferrer" href="https://www.youtube.com/results?search_query=eating+Hákarl" target="_blank">here's a bunch of youtube videos that may tickle your fancy.</a></p>

			<div class="videowrapper">
				<iframe title="home-video" width="100%" height="349" src="https://player.vimeo.com/video/179654756"></iframe>
			</div>
  <p>It's 2024 and I've not done a great job of keeping this website up-to-date but I'm hoping to stick more things here soon xoxo</p>

		</div>
    )
}

export { Home }
